import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import googlePng from "../../../assets/googlePng.png";
import googleIcon from "../../../assets/googleIcon.png";
import { TiStarFullOutline } from "react-icons/ti";
import { TiStarHalfOutline } from "react-icons/ti";
import { TiStarOutline } from "react-icons/ti";
import { Link } from "react-router-dom";

const Testimonials = ({ data, language }) => {
  const [expanded, setExpanded] = useState({});
  const [selectedTestimonial, setSelectedTestimonial] = useState(null);

  // const toggleExpand = (id) => {
  //   setExpanded((prev) => ({
  //     ...prev,
  //     [id]: !prev[id],
  //   }));
  // };

  const renderStars = (rating) => {
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);

    return (
      <>
        {[...Array(fullStars)].map((_, index) => (
          <TiStarFullOutline
            key={`full-${index}`}
            className="text-warning fs-5"
          />
        ))}
        {hasHalfStar && <TiStarHalfOutline className="text-warning fs-5" />}
        {[...Array(emptyStars)].map((_, i) => (
          <TiStarOutline key={`empty-${i}`} className="text-warning fs-5" />
        ))}
      </>
    );
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
    <section
      className="cs_testimonial_area bg-light py-5"
      style={{ marginTop: "30px" }}
    >
      <div className="container">
        <div className="row align-items-center">
          {/* Left Section */}
          <div className="col-lg-5 d-flex flex-column align-items-center justify-content-center text-center">
            {language === "ar" ? (
              <div className="cs_testimonial_thumbnail">
                <h3>
                  عيادات ايليت بودي هوم التجميلية - التنحيف I إزالة الشعر
                  بالليزر I بوتوكس I فيلر
                </h3>
                <p className="d-flex align-items-center justify-content-center mb-3">
                  <span className="me-2">
                    أراء عملائنا بناءً على 860 تقييمًا من جوجل
                  </span>
                  <img
                    src={googlePng}
                    alt="Google"
                    className="img-fluid"
                    style={{ width: "80px" }}
                    loading="lazy"
                  />
                </p>
              </div>
            ) : (
              <div className="cs_testimonial_thumbnail">
                <h3>
                  Elite Body Home Aesthetic Polyclinic - Slimming | Laser Hair
                  Removal | Botox Fillers
                </h3>
                <p className="d-flex align-items-center justify-content-center mb-3">
                  <span className="me-2">Based on 860 reviews powered by</span>
                  <img
                    src={googlePng}
                    alt="Google"
                    className="img-fluid"
                    style={{ width: "80px" }}
                    loading="lazy"
                  />
                </p>
              </div>
            )}
            <button
              className="btn btn-primary d-flex align-items-center px-4 py-2 rounded-pill shadow-sm border-0"
              onClick={() => {
                window.location.href =
                  "https://www.google.com/search?hl=en-IN&gl=in&q=Elite+Body+Home+Polyclinic";
              }}
            >
              <span className="text-white fw-semibold me-2">Review us on</span>
              <div
                className="bg-white rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: "24px", height: "24px" }}
              >
                <img
                  src={googleIcon}
                  alt="Google Logo"
                  width="18"
                  height="18"
                  loading="lazy"
                />
              </div>
            </button>

            <a
              href="https://www.google.com/search?hl=en-IN&gl=in&q=Elite+Body+Home+Polyclinic#lrd=0x3e5f43f5e67bd68b:0x3d823650a229b565,1,,,,"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none d-inline-flex align-items-center text-primary fw-semibold"
            >
              View All
              <i className="ms-2 bi bi-box-arrow-up-right"></i>
            </a>
          </div>

          {/* Right Section - Testimonials Carousel */}
          <div className="col-lg-7">
            <div className="cs_testimonial_content">
              <Slider {...settings}>
                {data?.data_values?.map((testimonial, index) => {
                  const starRating = parseFloat(testimonial?.Star);
                  return (
                    <div
                      key={index}
                      className="cs_testimonial bg-white p-4 rounded shadow"
                    >
                      {/* Star Rating */}
                      <div className="mb-3">{renderStars(starRating)}</div>

                      {/* Comment with Read More */}
                      <p
                        className="mb-3"
                        style={{
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: expanded[testimonial.id]
                            ? "unset"
                            : 3,
                          WebkitBoxOrient: "vertical",
                        }}
                      >
                        {testimonial.Comment}
                      </p>

                      {/* See More Button */}
                      <button
                        className="btn btn-link p-0 text-decoration-none"
                        onClick={() => setSelectedTestimonial(testimonial)}
                      >
                        See More
                      </button>

                      {/* User Info */}
                      <div className="d-flex align-items-center mt-4">
                        <div className="me-3">
                          <img
                            src={testimonial.ProfileImage}
                            alt={testimonial.UserName}
                            className="rounded-circle"
                            style={{
                              width: "60px",
                              height: "60px",
                              objectFit: "cover",
                            }}
                          />
                        </div>
                        <div>
                          <h5 className="mb-0">{testimonial.UserName}</h5>
                          <p className="text-muted mb-0">Customer</p>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for Full Testimonial */}
      {selectedTestimonial && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }} // Dark overlay
        >
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div
              className="modal-content p-3"
              style={{
                border: "3px solid #c69933", // Golden border
                borderRadius: "12px", // Rounded corners
                boxShadow: "0px 0px 20px rgba(198, 153, 51, 0.5)", // Soft glowing effect
              }}
            >
              {/* Close Button */}
              <div className="d-flex justify-content-end">
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSelectedTestimonial(null)}
                ></button>
              </div>

              <div className="modal-body">
                {/* Profile Section */}
                <div className="d-flex align-items-center mb-3">
                  <img
                    src={selectedTestimonial.ProfileImage}
                    alt={selectedTestimonial.UserName}
                    className="rounded-circle me-3"
                    style={{
                      width: "80px",
                      height: "80px",
                      objectFit: "cover",
                      border: "2px solid #c69933", // Border around image
                      padding: "2px",
                    }}
                  />
                  <div>
                    <h5 className="mb-0 fw-bold text-dark">
                      {selectedTestimonial.UserName}
                    </h5>
                    <p className="text-muted mb-0">Customer</p>
                  </div>
                </div>

                {/* Star Rating */}
                <div className="mb-3">
                  {renderStars(parseFloat(selectedTestimonial.Star))}
                </div>

                {/* Full Testimonial Text */}
                <p className="text-dark">{selectedTestimonial.Comment}</p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Testimonials;
